import { type LightboxMedia } from './LightboxGallery';

type Medias = {
  alt: string;
  zoom?: string;
};

export function buildLightboxSlides(prop: Readonly<Medias[]>): LightboxMedia[] {
  const medias = prop;

  return medias
    .filter((media) => media.zoom)
    .map((media) => ({
      src: media.zoom!,
      alt: media.alt,
      description: media.alt,
    }));
}
